import api from "./axios";

export const getWorkspaces = () => api.get("/workspaces");
export const getCurrentWorkspace = () => api.get("/workspaces/current");
